import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { CommandContribution, CommandRegistry } from '@patsnap/tahiti-core';
import { createDialog } from '@patsnap/tahiti-core';

const minorLanguageTranslationDialogService = createDialog(() => import('../components/MinorLanguageTranslationDialog.vue'));

@injectable()
export class FtoCommandContribution implements CommandContribution {
    private _handleOpenMinorLanguageTranslationDialog(payload: { translatedText: string }): Promise<{ translatedInput: string }> {
        return new Promise((resolve, reject) => {
            const instance = minorLanguageTranslationDialogService();
            instance.onSubmit(async(data, next) => {
                try {
                    resolve(data);
                    await next();
                } catch (error) {
                    const err = error instanceof Error ? error : new Error(String(error));
                    reject(err);
                    next(false);
                }
            });
            instance.onCancel(() => {
                reject(new Error('User cancelled translation'));
            });
            instance.open(payload);
        });
    }

    registerCommands(commands: CommandRegistry): void {
        commands.registerCommand({
            id: 'fto:open-minor-language-translation-dialog',
        }, {
            execute: (payload: { translatedText: string }) => {
                return this._handleOpenMinorLanguageTranslationDialog(payload);
            },
        });
    }
}

declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /**
         * 打开小语种翻译提示对话框
         * @param commandId - 命令ID
         * @param payload - 对话框参数
         * @returns Promise，resolve时返回用户接受的翻译后文本
         */
        executeCommand(commandId: 'fto:open-minor-language-translation-dialog', payload: { translatedText: string }): Promise<{ translatedInput: string }>;
    }
}
